import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { delay, getCurrentColor } from "@Shared/utils/utils";
import trophyGoldAsset from "@Broker/@Assets/img/trophy-gold.png";
import trophySilverAsset from "@Broker/@Assets/img/trophy-silver.png";
import trophyBronzeAsset from "@Broker/@Assets/img/trophy-bronze.png";
import tinyColor from "tinycolor2";
import { merge, isEmpty } from "lodash";
import i18n from "@Shared/i18n";
import { APPLICATION_SYNC_ERRORS } from "@Shared/utils/constants";
import { ENUM_FILOGIX_STATUS } from "@Shared/js/enum";
export const TROPHIES_ASSETS = [trophyGoldAsset, trophySilverAsset, trophyBronzeAsset];
export const setLoadingButton = (button, span) => {
  $(button).addClass("disabled");
  $(span).prepend("<i id='btn-loading' class='fa fa-circle-o-notch fa-spin fa-fw'></i>");
};
export const setActiveButton = button => {
  $(button).removeClass("disabled");
  $("#btn-loading").remove();
};
export const getCurrentStyles = () => {
  const bodyStyles = window.getComputedStyle(document.body);
  const {
    primary,
    secondary,
    primaryAlt,
    primaryRGB,
    primaryClear
  } = getCurrentColor();
  const hslColors = {};
  for (let i = 1; i <= 6; i++) {
    hslColors[`primary${i}`] = bodyStyles.getPropertyValue(`--primary-${i}`);
  }
  return `:root {
    --primary: ${primary};
    --primary-alt: ${primaryAlt};
    --primary-rgb: ${primaryRGB};
    --primary-clear: ${primaryClear};
    --secondary: ${secondary};
    --primary-1: ${hslColors.primary1};
    --primary-2: ${hslColors.primary2};
    --primary-3: ${hslColors.primary3};
    --primary-4: ${hslColors.primary4};
    --primary-5: ${hslColors.primary5};
    --primary-6: ${hslColors.primary6};
  }`;
};
export const encode64 = string => {
  return btoa(unescape(encodeURIComponent(string)));
};
export const decode64 = encoded => {
  return decodeURIComponent(escape(atob(encoded)));
};
export const timeBombTooltip = async (target, tooltipOptions = {}, delayTime = 3000) => {
  target.tooltip(tooltipOptions).tooltip("show");
  target.one("hidden.bs.tooltip", () => target.tooltip("dispose"));
  await delay(delayTime);
  target.tooltip("hide");
};
export const openPopoverWindow = (url, options = {}) => {
  var _context;
  const defaultOptions = {
    height: 500,
    width: 500,
    left: 100,
    top: 100,
    resizable: "yes",
    scrollbars: "yes",
    toolbar: "yes",
    menubar: "no",
    location: "no",
    directories: "no",
    status: "yes"
  };
  const mergedOptions = merge(defaultOptions, options);
  const windowOptions = _mapInstanceProperty(_context = _Object$keys(mergedOptions)).call(_context, key => `${key}=${mergedOptions[key]}`).join(",");
  return window.open(url, "popUpWindow", windowOptions);
};
export const VALID_TIMELINE_ITEMS = ["note", "follow-up", "email", "file", "checklist", "automation", "account-creation", "client-application-request", "drip-campaign-creation", "event"];
export const DEPRECATED_CLIENT_PROFILE_DETAILS = ["upcomingDate", "closingDate", "renewalDate"];

/**
 * TODO: Find non jquery replacement for this
 *
 */
export const alignItem = (target, add, remove) => {
  var _context2;
  target = _findInstanceProperty(_context2 = $("#main-content")).call(_context2, target);
  target.addClass(add);
  target.removeClass(remove);
};
export const buttonPreview = action => {
  if (action === "add" && !$(".preview-mode").exists()) {
    $(".row.header .button-wrapper:first").append(`<button disabled class='mr-1 btn btn-white float-right btn-sm preview-mode'>${this.$t("global.actions.previewChanges")}</button>`);
    $(".row.header > div:nth-child(3) .dropdown-item").append(`<button disabled class='btn btn-primary float-right btn-sm preview-mode'>${this.$t("global.actions.previewChanges")}</button>`);
  } else {
    $(".preview-mode").remove();
  }
};
export const handleAlignment = page => {
  $(".submit-changes").show();
  if (page === "themes") {
    buttonPreview("add");
    return;
  }
  if (page === "application-form" || page === "disclaimers") {
    $(".submit-changes").hide();
  }
  alignItem(".row.header > div:first-child", "col-md-7", "col-md-8");
  buttonPreview("remove");
};
export const getReadableOppositeColor = color => {
  if (tinyColor(color).isDark() || tinyColor(color).getLuminance() < 0.5) return "#ffffff";
  return "#565656";
};
export const getFileName = (file, raw = false) => {
  var _ref, _file$name, _context3;
  const fileName = (_ref = (_file$name = file.name) != null ? _file$name : file.fileName) != null ? _ref : file.filename;
  if (raw) return _sliceInstanceProperty(_context3 = fileName.split(".")).call(_context3, 0, -1).join(".");
  return fileName;
};
export const parseSyncStatus = (status, options = {
  error: {
    showDealId: true
  }
}) => {
  if (status.syncing) return {
    message: i18n.t("filogix.expertSync.syncing"),
    type: "primary",
    description: i18n.t("filogix.expertSync.syncInProgress"),
    code: "syncing"
  };
  if (status.expertApplicationId && !status.details.isError) return {
    message: i18n.t("filogix.expertSync.linkedID", {
      expertApplicationId: status.expertApplicationId
    }),
    type: "success",
    description: i18n.t("filogix.expertSync.linkedIDFromExpert"),
    code: "success"
  };
  if (!isEmpty(status.details) && status.details.isError) {
    const message = status.expertApplicationId && options.error.showDealId ? `${i18n.t("filogix.expertSync.linkedID", {
      expertApplicationId: status.expertApplicationId
    })} (${i18n.t("filogix.expertSync.unableToSync")})` : i18n.t("filogix.expertSync.unableToSync");
    return {
      message,
      type: "danger",
      description: getApplicationSyncErrorMessage(status),
      code: "unable-to-sync",
      isErrorWithFilogixDetails: isErrorWithFilogixDetails(status)
    };
  }
  return {
    message: i18n.t("filogix.expertSync.syncing"),
    type: "info",
    description: i18n.t("filogix.expertSync.yourApplicationHasNotStartedSyncingProcess"),
    code: "not-synced"
  };
};
export const getApplicationSyncEventTypeText = (eventType = "") => {
  if (isEmpty(eventType)) return "";
  return i18n.t(`filogix.expertSync.${eventType}`);
};
export const getApplicationSyncErrorMessage = (status, onlyPath = false, expert = false) => {
  var _status$details, _status$details2;
  const isError = ((_status$details = status.details) == null ? void 0 : _status$details.isError) || status.isError;
  if (!isError) return "";
  const errorType = ((_status$details2 = status.details) == null ? void 0 : _status$details2.errorType) || status.errorType || "";
  const isValidError = _includesInstanceProperty(APPLICATION_SYNC_ERRORS).call(APPLICATION_SYNC_ERRORS, errorType);
  const basePath = isValidError ? `filogix.expertSync.errorMessages.${errorType}` : `filogix.expertSync.errorMessages.${expert ? "UNKNOWN_ERROR_SNOOPY" : "UNKNOWN_ERROR"}`;
  return onlyPath ? basePath : i18n.t(basePath);
};
export const isErrorWithFilogixDetails = status => {
  var _status$details3, _context4;
  const errorType = ((_status$details3 = status.details) == null ? void 0 : _status$details3.errorType) || status.errorType || "";
  return _includesInstanceProperty(_context4 = ["AGENT_NOT_VERIFIED", "AGENT_MISCONFIGURED"]).call(_context4, errorType);
};
export const getNewStatusAfterSubmission = (currentStatus, completeStatus, isAlreadyCompleted = false) => {
  if (currentStatus === ENUM_FILOGIX_STATUS.accepted || isAlreadyCompleted && currentStatus !== ENUM_FILOGIX_STATUS.cancelled) return completeStatus;
  return ENUM_FILOGIX_STATUS.cancelled;
};
export const formatAgentForAvatar = ({
  agentUsername: username,
  agentFullName
}) => {
  const [givenName, familyName = ""] = agentFullName.split(" ");
  return {
    username,
    givenName,
    familyName
  };
};